import swal from "./swal";

export async function confirmBulkAction({ actionLabel, count, entityLabel = "items" }) {
  return swal({
    title: `${actionLabel}?`,
    text: `This will apply to ${count} selected ${entityLabel}.`,
    icon: "warning",
    buttons: ["Cancel", "Continue"],
    dangerMode: /delete/i.test(actionLabel),
  });
}

export async function runBulkIds(ids, runner) {
  let success = 0;
  let failed = 0;

  for (const id of ids) {
    try {
      await runner(id);
      success += 1;
    } catch {
      failed += 1;
    }
  }

  return { success, failed };
}

export function showBulkResult({ actionLabel, success, failed, skipped = 0 }) {
  if (failed === 0 && skipped === 0) {
    swal("Success", `${actionLabel} completed for ${success} item(s).`, "success");
    return;
  }

  const parts = [`${success} succeeded`];
  if (failed) parts.push(`${failed} failed`);
  if (skipped) parts.push(`${skipped} skipped`);

  swal(failed ? "Partially completed" : "Completed", parts.join(", "), failed ? "warning" : "success");
}
